<template>
    <DFormRow
        :label="__('customers.contracts.billed_until')"
        :error="errors.billed_until_date"
        :is-required="isRequired"
    >
        <DDateFormatInput
            id="billed_until_date"
            format="YYYY-MM-DD"
            :model-value="modelValue"
            type="date"
            @update:modelValue="$emit('update:modelValue', $event)"
            @update:value="$emit('valueChanged')"
        />
    </DFormRow>
</template>

<script>
export default {
    name: 'BilledUntil',
    props: {
        modelValue: {
            type: [String, Number],
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        isRequired: {
            type: Boolean,
            default: false
        }
    },
    emits: ['valueChanged', 'update:modelValue']
}
</script>
